var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea8b49;}.cls-2,.cls-3{fill:#fff;}.cls-4{fill:#ffbf57;}.cls-5{fill:#efecea;}.cls-6{fill:#ffd15c;mix-blend-mode:screen;}.cls-3{opacity:0;}.cls-7{isolation:isolate;}.cls-8{fill:none;stroke:#ffd15c;stroke-linecap:round;stroke-linejoin:round;stroke-width:8.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 42.77,
    y: 99.2,
    width: 70.68,
    height: 40.96,
    rx: 8.3,
    ry: 8.3,
    transform: "translate(107.5 -20.18) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 58.36,
    y: 86.08,
    width: 111.13,
    height: 39.57,
    rx: 8.14,
    ry: 8.14,
    transform: "translate(269.34 100.16) rotate(135)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M161.09,124.62c-16.64,43.62-74.78,55.96-107.68,22.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M164.19,114.33c-.15,.69-.31,1.38-.48,2.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M46.14,62.13c37.56-51.48,118.13-25.89,119.5,37.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.38,71.82c.29-.61,.6-1.21,.91-1.82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177,45.19c-5.74,0-10.41-7.43-10.41-10.93,0-.58-1.24-.58-1.24,0,0,3.34-4.29,10.93-11.07,10.93-.58,0-.58,1.24,0,1.24,5.92,0,11.07,8.1,11.07,10.93,0,.58,1.24,.58,1.24,0,0-3.36,4.81-10.93,10.41-10.93,.58,0,.58-1.24,0-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.78,64.98c-3.12,0-5.65-4.03-5.65-5.93,0-.32-.67-.32-.67,0,0,1.81-2.33,5.93-6.01,5.93-.31,0-.31,.67,0,.67,3.21,0,6.01,4.39,6.01,5.93,0,.32,.67,.32,.67,0,0-1.82,2.61-5.93,5.65-5.93,.31,0,.31-.67,0-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40.92,121.46c-4.93,0-8.93-6.38-8.93-9.37,0-.5-1.07-.5-1.07,0,0,2.87-3.68,9.37-9.5,9.37-.5,0-.5,1.06,0,1.06,5.08,0,9.5,6.95,9.5,9.37,0,.5,1.07,.5,1.07,0,0-2.88,4.13-9.37,8.93-9.37,.5,0,.5-1.06,0-1.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.97,
    y: 87.47,
    width: 70.68,
    height: 40.96,
    rx: 8.3,
    ry: 8.3,
    transform: "translate(98.1 -20.93) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.55,
    y: 74.35,
    width: 111.13,
    height: 39.57,
    rx: 8.14,
    ry: 8.14,
    transform: "translate(254.55 82.84) rotate(135)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 135.13,
    cy: 57.39,
    r: 4.68
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.4ae3ffaea07affab751cb9e7a00dd9eb.svg";
export { ForwardRef as ReactComponent };